import { Trans } from 'react-i18next';
import { useSupportEmail } from '@/contexts/SupportEmail/SupportEmailContext';
import styles from './DemoTestCallBanner.module.scss';

interface DemoTestCallBannerProps {
  formattedTime: string;
  conferenceId: string | undefined;
}

export function DemoTestCallBanner({
  formattedTime,
  conferenceId,
}: DemoTestCallBannerProps) {
  const { supportEmail, supportEmailHref } = useSupportEmail();
  const subject = encodeURIComponent(
    `AI Interview Technical Issues (ref: ${conferenceId ?? 'unknown'})`
  );
  const mailtoHref = `${supportEmailHref}?subject=${subject}`;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.message}>
        <Trans
          i18nKey="aiInterview.testCallBanner.message"
          values={{ email: supportEmail }}
          components={{
            1: (
              <a
                href={mailtoHref}
                className={styles.link}
                data-testid="demo-test-call-banner__support-email-link"
              />
            ),
          }}
        />
      </span>
      <span className={styles.timer}>{formattedTime}</span>
    </div>
  );
}
